export default "__VITE_PUBLIC_ASSET__15f53813__"